import axios from '@/plugins/axios'

class NotificationService {
  async getNotifications() {
    const { data } = await axios.get('/sum/api/alarms').then()
    return data
  }

  // 알림 삭제(읽음처리)
  async deleteAlarms(param) {
    const { data } = await axios
      .delete('/sum/api/alarms?alertSeqId=' + param)
      .then()
    return data
  }
}

export default new NotificationService()
